module.exports = __webpack_public_path__ + "img/sport_equipment.5f6f0c48.png";